var _rect, _path, _path2, _g, _path3, _path4, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    rx: 8,
    fill: "#9F1C6B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4985_42831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 8,
    width: 27,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.99438H43.0011V31.0056H17V8.99438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4985_42831)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4985_42831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 8,
    width: 26,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4229 8.99524C38.0594 8.99524 37.6777 9.0308 37.2773 9.10578C34.3153 9.6564 32.8808 11.655 32.8808 11.655C32.8808 11.655 34.6789 11.0633 36.4705 11.0633C36.4919 11.0633 36.5131 11.0633 36.5353 11.0633C38.3565 11.0778 39.3765 12.0554 39.3462 13.3736C39.3125 14.8208 38.1603 16.8236 37.086 18.3354C35.2198 20.9622 31.7416 23.8398 28.06 23.8398C26.3768 23.8398 24.6518 23.2384 23.0185 21.7354C18.4696 17.5501 17.5905 9.97598 17.5905 9.97598C16.147 16.0277 17.1836 27.0759 24.3177 30.2314C25.5299 30.7674 26.7338 31.0054 27.9108 31.0054C33.9378 31.0054 39.2419 24.7682 41.2428 20.502C43.1928 16.3441 43.5596 12.7157 42.0692 10.78C41.21 9.66447 39.9921 8.99524 38.4229 8.99524Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4985_42831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6152 8.59106H43.3914V31.4085H16.6152V8.59106Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4985_42831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 14,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1855 9.43018H32.8864V18.3483H19.1855V9.43018Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4985_42831)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4985_42831",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 14,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8754 18.1843C32.2443 18.2845 31.5968 18.3361 30.9378 18.3361C25.3563 18.3361 20.6513 14.6439 19.2109 9.60777C19.8421 9.50764 20.4896 9.45593 21.1486 9.45593C26.7293 9.45593 31.4351 13.1482 32.8754 18.1843Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4985_42831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6113 8.59241H43.3875V31.4099H16.6113V8.59241Z",
    fill: "#80C342"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeraIcon);
export default __webpack_public_path__ + "static/media/teraIcon.55be618063f316917639ad7795e66ecd.svg";
export { ForwardRef as ReactComponent };